import React, {Component} from 'react';
import {Tooltip, Icon, Modal, Input, message, Checkbox} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import {uuid} from "../../../utils";
import videoIcon from "./videoIcon.png";
import {Video} from "../../../view/resource/view/dialog/CurrencyResourceDialog";
import "./fileItem.css"
class VideoNormalFileItem extends BaseComponent {

    static defaultProps = {
        showEdit: true
    };

    state={
        visible:false,
        // isHover: "none",
    };

    fileNameDialogKey=uuid();
    fileName;

    renderMask(file, size){
        let percent = file.percent;
        let allWidth = size - 10;
        let msg = "上传中...";
        if(percent === 100){
            if(file.response && file.response.thumbnailsPlayPath){
                return <></>;
            }else{
                msg = "处理中...";
            }
        }
        return <>
            <div style={{width:size,height:size, background:"#000",position:"absolute",zIndex:997,top:10,left:30,opacity:0.5}}/>
            <div style={{color:"#fff",position:"absolute",zIndex:999,top:25,left:40}}>{msg}</div>
            <div style={{width:allWidth,height:5,background:"#fff",position:"absolute",zIndex:998,left:35,bottom:18,borderRadius:5}}/>
            <div style={{width:allWidth * percent / 100,height:5,background:this.themeBgColor,position:"absolute",zIndex:998,left:35,bottom:18,borderRadius:5}}/>
        </>
    }

    render() {
        const {file, size} = this.props;
        let suffix = file.suffix ? file.suffix : file.ext;
        if(!this.fileName){

            this.fileName = file?.originFileObj?.name;
        }
        if(!this.fileName){
            this.fileName = file.name;
        }
        let src = videoIcon;
        if(file.response && file.response.thumbnailsPlayPath){
            src = file.response.thumbnailsPlayPath;
        }
        if(file?.extendedAttributeJson?.mp4Path){
            file.path =file.extendedAttributeJson.mp4Path
        }
        if(file?.response?.mp4Path){
            file.path =file.response.mp4Path
        }
        if(file?.mp4Path){
            file.path =file.mp4Path
        }
        let percent = file.percent;
        const imgSize = 69;
        return <table cellPadding={0} style={{background:"#f4f6fc",border:"1px solid #f1f3f4",marginRight: 20,marginBottom: 32,float:"left",cursor:'pointer'}} cellSpacing={0} width={size} height={size}><tbody><tr>
            <td height={89} valign={"middle"} align={"center"} style={{position:"relative"}}
                // onmouseenter={(e) => {
                //     if (file?.path) {
                //         this.setState({isHover: "block"})
                //     }
                // }}
                className={"rmt-fileItem"}
            >
                {this.props.showCheck || !file?.path?null: <div className={"hover"}
                    // onmouseleave ={(e) => this.setState({isHover: "none"})}
                >
                    <div style={{
                    width: 131,
                    height: 89,
                    background: 'rgba(0,0,0,0.4)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'absolute',
                    padding: '0 10px',
                    top:0,
                    zIndex:9
                }}>
                    <Icon type={'play-circle'} style={{width: 25, height: 25, color: "#fff",marginRight:10, cursor: 'pointer'}}
                    onClick={()=>{this.detailDialogVideo.show()}}/>
                        {this.props.showDelete?null:<Icon type={'delete'} style={{width: 25, height: 25, color: "#fff", cursor: 'pointer'}}
                                                       onClick={() => {
                                                           this.props.onRemove(file)
                                                       }}
                        />}

                    </div>
                    </div>}

                <img src={src} style={{objectFit:"cover",width:imgSize,height:imgSize,}} onClick={()=>{
                    if(this.props.showCheck){
                        this.detailDialogVideo.show()
                    }
                }}/>
                {
                    (()=>{
                        let fileName = this.fileName;
                        let name = this.fileName.substring(0, this.fileName.lastIndexOf("."));
                        return <Modal
                            key={this.fileNameDialogKey}
                            title={"修改名称"}
                            maskClosable={false}
                            width={300}
                            visible={this.state.visible}
                            onOk={()=>{
                                if(fileName){
                                    this.fileName = fileName;
                                    this.setState({visible:false});
                                    let file = JSON.parse(JSON.stringify(this.props.file));
                                    file.originFileObj.name = fileName;
                                    if(typeof this.props.isSyncModifiedFileNameFn ==='function') {
                                        let params = { 
                                            name: fileName.slice(0,fileName.lastIndexOf('.')),
                                            md5: file.response.md5,
                                        };
                                        this.props.isSyncModifiedFileNameFn.call(this,params,()=>{
                                            this.props.onEditFileNameCall(file, fileName);
                                            message.success('修改成功');
                                        },this);
                                    }else{
                                        this.props.onEditFileNameCall(file, fileName);
                                    }
                                }else{
                                    message.destroy();
                                    message.error("标题不能为空！")
                                }
                            }}
                            onCancel={()=>{
                                this.fileNameDialogKey=uuid();
                                this.setState({visible:false})
                            }}
                        >
                            <Input style={{width: 210}} defaultValue={name} onChange={(e)=>{fileName = e.target.value + '.'+ suffix;}} /><span> . {suffix}</span>
                        </Modal>
                    })()
                }
                {this.props.showCheck?  <td style={{position: 'absolute',top:0,right:0,zIndex:'9',}} ><Checkbox checked={file.checked}  onChange={(e)=>{
                    this.props.onChange&& this.props.onChange(!file.checked,file)
                }}></Checkbox></td>:null}
                {this.renderMask(file, imgSize)}
            </td>
        </tr>
        <tr height={0}>
            <td><Video ref={ref => this.detailDialogVideo = ref} path={file.path}/></td>

        </tr>

        <tr>
            <td style={{padding:"0 10px",justifyContent: "spaceBetween", display: "flex"}} valign={"middle"} align={"center"}>
                <Tooltip placement={"bottomLeft"} title={this.fileName}><div className={"text-pointer"} style={{width:size-(this.props.showEdit?35:21)}}>{this.fileName}</div></Tooltip>
                {this.props.showEdit && <div><Icon type={"edit"}
                           onClick={()=>percent === 100 && file.response && file.response.path &&this.setState({visible:true})}
                           style={{color:this.themeBgColor,cursor:"pointer"}}
                /></div>}
            </td>
        </tr></tbody>
        </table>;
    }
}

export default VideoNormalFileItem;
